module.exports = __webpack_public_path__ + "img/2020-147_Stravenky-logoA-2025-09.b3a3a0d0.png";